import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button } from 'reactstrap';

import { profileActions } from '../../../core/profile/actions';
import { ChangePasswordForm } from './ChangePasswordForm';
import { convertCamelCase, passwordStrengthChecker } from '../../../core/helper';

export const UserChangePassword = ({ toggleShowForm }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const profile = useSelector(state => state.profile);
    const [formErrors, setformErrors] = useState({
        currentPassword: '',
        password: '',
        confirmPassword: '',
    });
    const [inputValues, setInputValues] = useState({
        currentPassword: '',
        password: '',
        confirmPassword: '',
    });
    const strength = passwordStrengthChecker(inputValues.password)

    useEffect(() => {
        if (profile.error && profile.error.data) {
            const errors = profile.error.data;
            let updatedErrors = { ...formErrors };

            Object.keys(errors).forEach(key => {
                const camelCaseKey = convertCamelCase(key);

                updatedErrors = {
                    ...updatedErrors,
                    [camelCaseKey]: errors[key][0]
                };
            });

            setformErrors(updatedErrors);
        }
    }, [profile.error])

    const handleInputChange = async ({ target }) => {
        const { name, value } = target;

        switch (name) {
            case "currentPassword":
                formErrors.currentPassword = "";
                break;
            case "password":
                formErrors.password =
                    value && value.length < 8 ? "Minimum 8 characters required" : "";
                formErrors.confirmPassword = (inputValues.confirmPassword && inputValues.confirmPassword !== value)
                    ? "Passwords do not match"
                    : ""
                break;
            case "confirmPassword":
                let matchPass = inputValues.password === value ? "" : 'Passwords do not match';
                !value ? formErrors.confirmPassword = "" :
                    formErrors.confirmPassword = value.length < 8 ? "Minimum 8 characters required" : matchPass;
                break;
            default:
                break;
        }

        setInputValues({
            ...inputValues,
            [name]: value
        });
    }

    const onSubmitUpdateInfo = async (e) => {
        e && e.preventDefault();
        if (formValid()) {
            const info_profile = {
                first_name: user.first_name,
                last_name: user.last_name,
                current_password: inputValues.currentPassword,
                password: inputValues.password,
                confirm_password: inputValues.confirmPassword,
            }

            dispatch(profileActions.updateProfile(info_profile));
        }
    }

    useEffect(() => {
        if (profile.success)
            window.location.reload();
    }, [profile.success]);

    const formValid = () => {
        let valid = true;
        let inputValuesRequired = ['currentPassword', 'password', 'confirmPassword']

        // validate form errors being empty
        Object.values(formErrors).forEach(val => {
            val.length > 0 && (valid = false);
        });

        // validate the form was filled out
        Object.keys(inputValues).forEach(key => {
            if (inputValuesRequired.includes(key)) {
                (inputValues[key] == '' || inputValues[key] == undefined) && (valid = false);
            }
        });

        (inputValues.password !== "" && inputValues.confirmPassword === "") && (valid = false);

        if (inputValues.password !== "" && strength === 'Too weak!') valid = false;

        return valid;
    };

    return (
        <div className="w-100">
            <Container fluid="md" className='mx-auto p-0'>
                <div className='pt-md-3 px-md-3 rounded border-md'>
                    <div className='d-flex justify-content-start align-items-center mb-3'>
                        <Button color='link' onClick={() => toggleShowForm('viewProfile')} className="p-0 text-body mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width={28} height={29} viewBox="0 0 28 29" fill='currentColor'>
                                <path d="M24.5,14.5c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3H6.5l6.4,6.4c0.1,0.1,0.1,0.2,0.2,0.3
                                    c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1
                                    c-0.1,0-0.2-0.1-0.3-0.2l-7.9-7.9c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
                                    L11.6,6c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6l-6.4,6.4h17.1
                                    c0.2,0,0.5,0.1,0.6,0.3C24.4,14,24.5,14.3,24.5,14.5z"
                                />
                            </svg>
                        </Button>
                        <h1 className='mb-0 libre-caslon-text-regular h3-md h4'>Change Password</h1>
                    </div>
                    <ChangePasswordForm
                        inputValues={inputValues}
                        handleInputChange={handleInputChange}
                        onSubmitUpdateInfo={onSubmitUpdateInfo}
                        formErrors={formErrors}
                        formValid={formValid}
                        strength={strength}
                        toggleShowForm={toggleShowForm}
                    />
                </div>
            </Container>
        </div>
    )
}
